export default __webpack_public_path__ + "static/media/remove.793226be.svg";